import React, { useRef, useEffect, useState } from "react";
import "./FadeInSection.css";

export default function FadeInSection({ children }) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(ref.current);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(ref.current);
  }, []);

  return (
    <div
      ref={ref}
      className={`fade-in-section ${isVisible ? "visible" : ""}`}
    >
      {children}
    </div>
  );
}
